import type { Currency } from '../stores/meetingStore';

/**
 * Calculate meeting cost based on attendees, hourly rate, and elapsed time
 * @param attendees Number of meeting attendees
 * @param hourlyRate Hourly rate per person
 * @param elapsedSeconds Elapsed time in seconds
 * @param currency Currency code for formatting
 * @returns Calculated cost in the specified currency
 */
export function calculateCost(
  attendees: number,
  hourlyRate: number,
  elapsedSeconds: number,
  currency: Currency
): number {
  if (attendees <= 0 || hourlyRate <= 0 || elapsedSeconds <= 0) {
    return 0;
  }

  // Calculate: (attendees × hourlyRate × elapsedSeconds) / 3600
  const totalCost = (attendees * hourlyRate * elapsedSeconds) / 3600;
  
  return totalCost;
}

/**
 * Calculate cost per second
 */
export function calculateCostPerSecond(
  attendees: number,
  hourlyRate: number
): number {
  if (attendees <= 0 || hourlyRate <= 0) {
    return 0;
  }
  
  return (attendees * hourlyRate) / 3600;
}
